import { apiGet, apiPost } from '@/utils/httpClient'
import { TranslationConfiguration } from "@/models/TranslationConfiguration";
import { AbbreviationSettings } from "@/models/AbbreviationSettings";


export const confugrationApi = {
    getUserSettins() {
        return apiGet('configuration/userSettings');
    },

    saveTranslationConfig(config: TranslationConfiguration) {
        return apiPost('configuration/saveTranslationConfig', config);
    },

    getAbbreviationDefaults() {
        return apiGet('configuration/abbreviationDefaults');
    },

    saveAbbreviations(settings: AbbreviationSettings) {
        return apiPost('configuration/abbreviations', settings, true);
    },

    markTourAsPassed() {
        return apiPost('configuration/markTourAsPassed');
    },

    skipTourToday() {
        return apiPost('configuration/skipTourToday');
    },

    markDesignUpdateSeen() {
        return apiPost('configuration/mark-design-update-seen');
    },

    hideUploadFileMessage() {
        return apiPost('configuration/uploadFileMessage');
    },

    userConfigOptions() {
        return apiGet('configuration/userConfigOptions');
    },

    basicConfigOptions() {
        return apiGet('configuration/basicConfigOptions');
    },

    getSubSubjectOptions(id: number) {
        return apiGet(`configuration/subSubject/${id}`);
    },

    updateConfiguration(documentId: Number, config: TranslationConfiguration) {
        return apiPost('configuration/updateDocumentConfig/' + documentId, config);
    },

    getTranslationConfig(id: number) {
        return apiGet(`configuration/documentConfig/${id}`);
    },

    getArchivedTranslationConfig(id: number) {
        return apiGet(`configuration/archivedDocumentConfig/${id}`);
    },

    getProofreadingTranslationConfig(id: number) {
        return apiGet(`configuration/proofreadingDocumentConfig/${id}`);
    }
}